<template>
<div class="chapter">
<div class="inner_page">
<blockquote><p class="left"><a id="pix"></a> <em>The valley spirit never dies;</em><br/>
<em>It is the woman, primal mother.</em><br/>
<em>Her gateway is the root of heaven and earth.</em><br/>
<em>It is like a veil barely seen.</em><br/>
<em>Use it; it will never fail.</em></p></blockquote>
<blockquote><p class="right">—L<span style="font-size: smaller">AO</span> T<span style="font-size: smaller">SU</span></p></blockquote>
<blockquote><p class="left"><em>Don't go opening your mouth about things</em><br/>
<em>that's none of your business. Hush up.</em><br/>
<em>Hold your mud.</em></p></blockquote>
<blockquote><p class="right">—D<span style="font-size: smaller">AISY</span></p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?f64470ea